export const toStrId = (value) => (value ? String(value) : '0');

export const toComparableId = (value) => (value == null ? '' : String(value));

export const areIdsEqual = (leftValue, rightValue) => toComparableId(leftValue) === toComparableId(rightValue);
